import { useEffect, useState } from "react"
import CheckboxField from "../../../../components/Checkbox/CheckboxField";
import { CountrySelectorDropdown } from "react-international-phone";
import { Dialog, DialogContent } from "@mui/material";
import DeletePartDialog from "./DeletePartDialog";

export const ConditionsMenu = ({ conditions, handleClose, preSelect, addClick }) => {

    const [selection, setSelection] = useState(new Set([1]));
    const [deleteItems, setDeleteItems] = useState([]);
    const [newItems, setNewItems] = useState([]);


    useEffect(() => {
   
        if (preSelect) setSelection(new Set(preSelect));
    }, [preSelect])


    const checkChange = (cId, newValue) => {
        setSelection(prev => {
            if (newValue) {
                let copy = new Set(prev.add(cId));
                return copy;
            } else {
                let copy = new Set(prev);
                copy.delete(cId)
                return copy;
            }
        })
    }

    const applySelection = () => {
        let newConditionIds = new Set([...selection].filter(x => !preSelect.includes(x)));
        let deleted = new Set([...preSelect].filter(x => !selection.has(x)));
        if (deleted.size > 0) {
            setDeleteItems(conditions.filter(i => deleted.has(i.id)));
            setNewItems(conditions.filter(j => newConditionIds.has(j.id)));
        }
        else {
            addClick({
                deleteConditions: deleted,
                newConditions: newConditionIds
            })
            handleClose();
        }

    }

    const proceed = () => {
        addClick({
            deleteConditions: new Set(deleteItems.map(i => i.id)),
            newConditions: new Set(newItems.map(i => i.id))
        });
        handleClose();
        setDeleteItems([]);
        setNewItems([]);
    }

    return (
        <div className='checkbox-menu-component'>
            <div className='conditions-list'>
                {conditions.map(c =>
                    <>
                        <CheckboxField grey checked={selection.has(c.id)} onChange={(newValue) => { checkChange(c.id, newValue) }} outlined key={c.id}>
                            {c.name}
                        </CheckboxField>
                    </>
                )}
            </div>
            <div className='buttons'>
                <button onClick={applySelection} className='filled small-size iconButton'>
                    {/* <i className='icon-add-new'></i> */}
                    <span>OK</span>
                </button>
                <button onClick={handleClose} className='filled small-size iconButton danger'>
                    <i className='icon-light-cross'></i>
                    <span>Cancel</span>
                </button>
            </div>
            <Dialog open={Boolean(deleteItems.length > 0)} onClose={() => {setDeleteItems([]); setNewItems([])}} BackdropProps={{ style: { backdropFilter: 'blur(5px)', background: "rgba(0,0,0,0.5)" } }}
                PaperProps={{

                    sx: {
                        borderRadius: '12px',
                        // boxShadow: 'var(--pop-over-shadow)'
                        maxWidth: '95vw',
                        // padding: '1rem'
                        // background: "magenta"
                    }

                }}>
                <DialogContent>

                    <DeletePartDialog
                        item={{}}
                        onClose={() => {setDeleteItems([]); setNewItems([])}}
                        onDelete={proceed}
                        message={<pre>
                            Are you sure you want to remove the following conditions: {deleteItems.map(d => `"${d.name}"`).join(", ")}?.
                            <br/>
                            This will also delete their related information.
                        </pre>}
                    >

                    </DeletePartDialog>
                </DialogContent>


            </Dialog>

        </div>
    )
}